import React, { useState } from "react";
import { useEffect } from "react";
import { htmlToText, trimString } from "../../components/Helpers/Common";
import { staticFiles } from "../../components/Helpers/Static";

const NO_IMAGE = staticFiles.noImage;

function SharePostCard({ item, idx, add, remove, isShow }) {
  function handleChange() {
    if (isShow == true) {
      remove(item.reflection_id);
    } else {
      add(item.reflection_id);
    }
  }

  let style = isShow ? "bg-blue" : "";
  style += " appearance-none rounded-full w-full h-full";

  return (
    <div className="flex w-full flex-row ">
      <div className="flex lg:flex-row flex-col-reverse gap-3 w-full justify-between">
        <div className="flex flex-col lg:flex-row">
          {/* Image */}
          <div className="w-full lg:w-56  flex-shrink-0 overflow-hidden">
            <img
              src={item.reflection_image ? item.reflection_image : NO_IMAGE}
              alt="postImage"
              className="export-image-grid object-cover border20px w-full h-auto"
              onError={(e) => {
                e.target.src = NO_IMAGE;
              }}
            />
          </div>

          {/* Content */}
          <div className="flex-1 pt-2 lg:pt-0 lg:px-4">
            <div className="mb-2 font-bold break-words text-base blackColor">
              {item.reflection_title}
            </div>
            <div className="break-words text-sm lightColor">
              {trimString(htmlToText(item.reflection_content), 300)}
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          {/* <p className='font-semibold blackColor text-base'>{idx + 1}</p> */}
          <div className="flex cursor-pointer mt-1">
            <input
              type="checkbox"
              className="cursor-pointer w-4 h-4 checkBoxCustom"
              checked={isShow}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SharePostCard;
